import { store } from '@/main';
import UserService from '@/services/user-service';

export const ACL = {
  roles: {
    admin: {
      permissions: [
        'view_agents', 'view_agent', 'create_agent', 'update_agent', 'destroy_agent', 'view_abonent',
        'create_abonent', 'update_abonent', 'destroy_abonent', 'export_csv_abonent',
        'view_role', 'create_role', 'update_role', 'destroy_role', 'view_doorphone',
        'create_doorphone', 'update_doorphone', 'change_device_doorphone', 'destroy_doorphone', 'import_keys_doorphone',
        'export_csv_doorphone', 'change_device_doorphone', 'view_device', 'create_device', 'update_device',
        'destroy_device', 'view_user',
        'create_user', 'update_user', 'destroy_user', 'get_address_doorphone', 'get_settings_doorphone',
        'update_settings_doorphone', 'open_door_doorphone', 'view_key', 'create_key', 'update_key', 'destroy_key',
        'reset_password_user', 'view_backup', 'create_backup', 'destroy_backup', 'view_region', 'view_regions',
        'create_region', 'update_region', 'destroy_region', 'get_region_skud_equipment', 'get_mto_sector_indicators', 'update_password_agent', 'view_any_rules', 'view_rules',
        'update_rules', 'import_relay', 'import_main-setup', 'view_manage_key', 'editing_plan_diapazon', 'show_mobile_hidder',
      ],
      routes: [
        'Home', 'Areas', 'Areas-new-area', 'Resident-accounts', 'Resident-accounts-edit', 'GeneralReport',
        'Resident-accounts-new', 'Resident-accounts-view', 'Agents', 'NewAgent', 'EditAgent', 'NewTypeAgent',
        'Management', 'Access-keys', 'EditKey', 'NewKey', 'Doorphone', 'NewGate', 'NewDoorphoneKey',
        'DetailDoorphone', 'EditDoorphone', 'Device', 'DetailDevice', 'EditDevice', 'NewDevice', 'EditManagementCompany',
        'MassFunction', 'EditDoorphoneGeneralInfoTab', 'EditDoorphoneSetupPlanTab', 'NotFound', 'NewManagementCompany',
        'EditDoorphoneAdministrationCodeTab', 'EditDoorphoneSoundSetupTab', 'EditDoorphoneTimeSetupTab', 'NewAbonent',
        'EditDoorphoneRelayTab', 'EditDoorphoneAdditionalSetupTab', 'EditDoorphoneAnalytics', 'EditMailNotification', 'EditDoorphoneDoors',
        'AnalyticsServerList', 'AnalyticsServerShow', 'Users', 'Admins', 'NewAdmin', 'EditAdmin', 'BaseResComplex',
        'EditEngineer', 'NewEngineer', 'Engineers', 'admin-engineer', 'manager', 'EditManager', 'NewManager', 'Managers',
        'call-center', 'CallCenters', 'EditCallCenter', 'NewCallCenter', 'GeneralIndicator', 'DetailAccessKey', 'EditDoorphoneLCD',
        'NewAnalytic', 'DetailClient', 'EditClient', 'NewClient', 'CarNumberSearchDetail', 'image', 'Image', 'Images', 'NewImage', 'DetailDoorphoneMobileDoorOpening',
        'DetailDoorphoneGeneralInfoNew', 'DetailDoorphoneListApartments', 'DetailDoorphoneKeys', 'DetailDoorphoneDoorOpening',
        'DetailDoorphoneCallLog', 'DetailDoorphoneTempCodeProvisionHistory', 'DetailDoorphoneServiceDoorCodeHistory', 'EditDoorphoneEntrance', 'ListClients', 'DetailClientCallLogClient', 'DetailClientGeneralInfoClient', 'DetailClientCarNumberChangesHistory', 'DetailClientGuestAccessHistory', 'DetailClientTempCodeProvisionHistory',
        'NewGateDoorphone', 'Reports', 'ReportTempCodeProvisionHistory', 'ReportServiceDoorCodeHistory', 'ReportDoorphoneAdMetrics', 'AdminFunction', 'DoorphoneActivation', 'ApartmentPayment', 'GettingLogData', 'DetailDoorphoneActions',
        'GroupManagement', 'EditAnalogLine', 'SipPasswordApartment', 'AgentChange', 'TheMap', 'TheMapIndividual', 'TheMapIndividualBarrier', 'AreasAreaDescription', 'MtoSectorDetail', 'ResidentialComplexes',
        'EditResidentialComplexes', 'UsersAgents', 'Barriers', 'BaseFormNewBarrier', 'DetailBarrier', 'EditBarrier', 'DetailBarrierGeneralInfo',
        'EditBarrierGeneralInfoTab', 'PACS', 'Gates', 'BaseFormNewGate', 'DetailGate', 'DetailGateGeneralInfo',
        'EditGate', 'EditGateGeneralInfoTab', 'NewDoorphone', 'DetailGateKeys', 'NewUser', 'Users', 'EditUser',
        'BarriersJournalGrz', 'BarriersListAbonents', 'ListAbonentsResComplex', 'BarriersListCarNumbers', 'ListCarsNumbersResComplex',
        'BarriersListTemporaryAbonents', 'ListTemporaryAbonentsResComplex', 'TravelLogClient', 'DetailBarrierNewGeneralInfo',
        'DetailGateNewGeneralInfo', 'MobileBarrierOpening', 'EditBarrierDoors', 'ListTravelLog', 'HomePageSettings', 'LkNotificationsAdmin', 'BarriersWhitePhoneNumbers',
        'WhitePhoneNumbersResComplex', 'MassOpenDoorSound',
      ],
    },
    agent: {
      permissions: [
        'reset_password_user', 'view_agents', 'view_agent', 'update_password_agent', 'view_abonent', 'create_abonent',
        'update_abonent', 'destroy_abonent', 'export_csv_abonent', 'view_doorphone', 'create_doorphone',
        'update_doorphone', 'change_device_doorphone', 'destroy_doorphone', 'get_address_doorphone',
        'get_settings_doorphone', 'update_settings_doorphone', 'open_door_doorphone', 'import_keys_doorphone',
        'export_csv_doorphone', 'change_device_doorphone',
        'view_key', 'create_key', 'update_key', 'destroy_key', 'view_device', 'create_device', 'update_device',
        'destroy_device', 'view_region', 'view_regions', 'view_any_rules', 'view_rules', 'update_rules',
      ],
      routes: [
        'Home', 'Resident-accounts', 'Access-keys', 'Doorphone', 'NewGate', 'DetailDoorphone', 'EditDoorphone',
        'NewDoorphoneKey', 'Device', 'DetailDevice', 'EditDevice', 'NewDevice', 'EditDoorphoneGeneralInfoTab',
        'EditDoorphoneSetupPlanTab', 'EditDoorphoneAdministrationCodeTab', 'NotFound', 'BaseResComplex',
        'EditDoorphoneSoundSetupTab', 'EditDoorphoneTimeSetupTab', 'EditDoorphoneRelayTab', 'ResidentialComplexes',
        'Resident-accounts-view', 'Resident-accounts-edit', 'Resident-accounts-new', 'EditKey', 'NewKey', 'InformationResidentComplex',
        'EditDoorphoneAdditionalSetupTab', 'MassFunction', 'DetailDoorphoneGeneralInfo', 'DetailDoorphoneListApartments',
        'DetailDoorphoneKeys', 'DetailDoorphoneDoorOpening', 'DetailDoorphoneCallLog', 'DetailDoorphoneTempCodeProvisionHistory', 'DetailDoorphoneServiceDoorCodeHistory', 'DetailAccessKey', 'NewGateDoorphone', 'EditAnalogLine',
        'TheMapIndividual', 'TheMapIndividualBarrier', 'Barriers', 'BaseFormNewBarrier', 'DetailBarrier', 'EditBarrier', 'DetailBarrierGeneralInfo',
        'EditBarrierGeneralInfoTab', 'Gates', 'PACS', 'BaseFormNewGate', 'DetailGate', 'DetailGateGeneralInfo',
        'EditGate', 'EditGateGeneralInfoTab', 'NewDoorphone', 'DetailGateKeys', 'BarriersJournalGrz', 'BarriersListAbonents',
        'BarriersListCarNumbers', 'BarriersListTemporaryAbonents', 'ListTemporaryAbonentsResComplex', 'DetailDoorphoneGeneralInfoNew',
        'DetailBarrierNewGeneralInfo', 'DetailGateNewGeneralInfo', 'MobileBarrierOpening', 'ListTravelLog', 'BarriersWhitePhoneNumbers',
        'WhitePhoneNumbersResComplex',
      ],
    },
    'admin-engineer': {
      permissions: [
        'view_agents', 'view_agent', 'view_abonent', 'export_csv_abonent', 'view_doorphone', 'create_doorphone',
        'update_doorphone', 'change_device_doorphone', 'destroy_doorphone', 'get_address_doorphone',
        'get_settings_doorphone', 'update_settings_doorphone', 'open_door_doorphone', 'import_keys_doorphone',
        'export_csv_doorphone', 'change_device_doorphone',
        'view_key', 'create_key', 'update_key', 'destroy_key', 'view_device', 'create_device', 'update_device',
        'destroy_device', 'view_region', 'view_regions', 'view_any_rules', 'view_rules', 'update_rules', 'import_relay',
        'import_main-setup', 'view_manage_key', 'editing_plan_diapazon', 'TravelLogClient', 'get_mto_sector_indicators',
      ],
      routes: [
        'Home', 'Resident-accounts', 'Access-keys', 'Agents', 'Doorphone', 'NewGate', 'DetailDoorphone', 'EditDoorphone',
        'NewDoorphoneKey', 'Device', 'DetailDevice', 'EditDevice', 'NewDevice', 'NewKey', 'BaseResComplex',
        'EditDoorphoneGeneralInfoTab', 'EditDoorphoneSetupPlanTab', 'EditDoorphoneAdministrationCodeTab',
        'EditDoorphoneSoundSetupTab', 'EditDoorphoneTimeSetupTab', 'EditDoorphoneRelayTab', 'EditDoorphoneLCD',
        'EditDoorphoneAdditionalSetupTab', 'MassFunction', 'DetailDoorphoneMobileDoorOpening', 'DetailDoorphoneGeneralInfo',
        'DetailDoorphoneListApartments', 'DetailDoorphoneKeys', 'DetailDoorphoneDoorOpening', 'DetailDoorphoneCallLog',
        'DetailDoorphoneTempCodeProvisionHistory', 'DetailDoorphoneServiceDoorCodeHistory', 'DetailDoorphoneActions', 'EditDoorphoneEntrance', 'ListClients', 'DetailClientGeneralInfoClient', 'EditAnalogLine',
        'DetailAccessKey', 'NewGateDoorphone', 'TheMapIndividual', 'TheMapIndividualBarrier', 'NotFound', 'DetailClient', 'DetailClientCarNumberChangesHistory', 'ResidentialComplexes',
        'Resident-accounts-view', 'Resident-accounts-edit', 'Resident-accounts-new', 'EditKey', 'EditResidentialComplexes',
        'Barriers', 'BaseFormNewBarrier', 'DetailBarrier', 'EditBarrier', 'DetailBarrierGeneralInfo', 'EditBarrierGeneralInfoTab',
        'Gates', 'PACS', 'BaseFormNewGate', 'DetailGate', 'DetailGateGeneralInfo', 'EditGate', 'BarriersJournalGrz',
        'EditGateGeneralInfoTab', 'NewDoorphone', 'DetailGateKeys', 'BarriersListAbonents', 'ListAbonentsResComplex',
        'BarriersListCarNumbers', 'ListCarsNumbersResComplex', 'BarriersListTemporaryAbonents', 'ListTemporaryAbonentsResComplex',
        'DetailDoorphoneGeneralInfoNew', 'DetailBarrierNewGeneralInfo', 'DetailGateNewGeneralInfo', 'MobileBarrierOpening',
        'EditBarrierDoors', 'ListTravelLog', 'EditDoorphoneDoors', 'BarriersWhitePhoneNumbers', 'WhitePhoneNumbersResComplex',
        'Areas', 'AreasAreaDescription', 'MtoSectorDetail', 'Reports', 'GeneralIndicator', 'ReportDoorphoneAdMetrics', 'ReportServiceDoorCodeHistory', 'MassOpenDoorSound',
      ],
    },
    manager: {
      permissions: [
        'view_agents', 'view_agent', 'view_abonent', 'create_abonent',
        'update_abonent', 'destroy_abonent', 'export_csv_abonent', 'view_doorphone',
        'get_settings_doorphone', 'open_door_doorphone', 'import_keys_doorphone',
        'view_key', 'create_key', 'update_key', 'destroy_key', 'view_device', 'create_device', 'update_device',
        'destroy_device', 'view_region', 'view_regions', 'view_any_rules', 'view_rules',
        'get_mto_sector_indicators',
      ],
      routes: [
        'Home', 'Resident-accounts', 'Access-keys', 'Agents', 'Doorphone', 'DetailDoorphone', 'EditDoorphone',
        'NewDoorphoneKey', 'EditDoorphoneSetupPlanTab', 'DetailDoorphoneGeneralInfo', 'DetailDoorphoneListApartments',
        'DetailDoorphoneKeys', 'DetailDoorphoneDoorOpening', 'DetailDoorphoneCallLog', 'DetailDoorphoneTempCodeProvisionHistory', 'DetailDoorphoneServiceDoorCodeHistory', 'DetailAccessKey', 'TheMapIndividual', 'TheMapIndividualBarrier',
        'NotFound', 'NewKey', 'Resident-accounts-view', 'Resident-accounts-edit', 'Resident-accounts-new', 'EditKey',
        'ResidentialComplexes', 'InformationResidentComplex', 'BaseResComplex', 'DetailClientGeneralInfoClient', 'DetailClient', 'DetailClientCarNumberChangesHistory',
        'PACS', 'Gates', 'DetailGate', 'DetailGateGeneralInfo', 'Barriers', 'DetailGateKeys', 'DetailBarrier', 'DetailBarrierGeneralInfo',
        'BarriersJournalGrz', 'BarriersListAbonents', 'ListAbonentsResComplex', 'ListCarsNumbersResComplex', 'DetailDoorphoneGeneralInfoNew',
        'DetailBarrierNewGeneralInfo', 'DetailGateNewGeneralInfo', 'MobileBarrierOpening',
        'Areas', 'AreasAreaDescription', 'MtoSectorDetail', 'Reports', 'GeneralIndicator', 'ReportServiceDoorCodeHistory',
      ],
    },
    'call-center': {
      permissions: [],
      routes: [
        'Home', 'Resident-accounts', 'DetailDoorphone', 'DetailDoorphoneGeneralInfo', 'DetailDoorphoneListApartments',
        'DetailDoorphoneDoorOpening', 'Doorphone', 'TheMapIndividual', 'TheMapIndividualBarrier', 'NotFound', 'Resident-accounts-view',
        'ResidentialComplexes', 'BaseResComplex', 'InformationResidentComplex', 'DetailClient', 'DetailClientGeneralInfoClient', 'DetailClientCarNumberChangesHistory',
        'PACS', 'Gates', 'DetailGate', 'DetailGateGeneralInfo', 'Barriers', 'DetailBarrier', 'DetailBarrierGeneralInfo',
        'DetailGateKeys', 'DetailDoorphoneGeneralInfoNew', 'BarriersJournalGrz', 'DetailBarrierNewGeneralInfo',
        'DetailGateNewGeneralInfo', 'MobileBarrierOpening',
      ],
    },
    master: {
      permissions: ['get_mto_sector_indicators'],
      routes: [
        'Home', 'DetailDoorphoneGeneralInfo', 'DetailDoorphoneListApartments', 'EditDoorphoneSetupPlanTab',
        'DetailDoorphoneDoorOpening', 'TheMapIndividual', 'TheMapIndividualBarrier', 'NotFound', 'EditDoorphone', 'EditDoorphoneGeneralInfoTab',
        'PACS', 'EditDoorphoneSoundSetupTab', 'EditDoorphoneDoors', 'EditAnalogLine', 'DetailDoorphone', 'DetailDoorphoneGeneralInfoNew',
        'DetailBarrier', 'DetailGate', 'DetailGateGeneralInfo', 'DetailBarrierGeneralInfo', 'DetailBarrierNewGeneralInfo',
        'DetailGateNewGeneralInfo', 'EditDoorphoneRelayTab',
        'Areas', 'MtoSectorDetail', 'Reports', 'GeneralIndicator',
      ],
    },
    'checkpoint-admin': {
      permissions: [],
      routes: [
        'Home', 'NotFound', 'ResidentialComplexes', 'BaseResComplex', 'InformationResidentComplex', 'ListAbonentsResComplex',
        'ListCarsNumbersResComplex', 'ListTemporaryAbonentsResComplex', 'TheMapIndividual', 'TheMapIndividualBarrier', 'ListTravelLog',
      ],
    },
  },
};

/**
 * Проверяет разрешение роли пользователя для открытия страницы
 *
 * @param {string} route
 * @returns {boolean}
 */
const canRoute = function (route) {
  const roleName = store.getters.roleName;
  return ACL.roles[roleName].routes.indexOf(route) > -1;
};

/**
 * Проверяет разрешения роли пользователя
 *
 * @param permission
 * @returns {*|boolean}
 * @deprecated
 */
const can = function (permission) {
  const roleName = store.getters.roleName;
  return ACL.roles[roleName] && ACL.roles[roleName].permissions.indexOf(permission) > -1;
};

/**
 * Проверяет разрешения роли пользователя
 *
 * @param permission
 * @returns {*}
 */
const checkPermission = function (permission) {
  const user = UserService.instance.user;
  return user.role.permissions.find(p => p.key === permission) !== undefined;
};

ACL.install = function (Vue) {
  Vue.prototype.$canRoute = canRoute;
  Vue.prototype.$can = can;
  Vue.prototype.$checkPermission = checkPermission;
};

export { canRoute };

export default ACL;
